
define('modules/application/wizard/classes/powerSupply',[

"app",

// Libs
"backbone",

//Classes
"./genericElement",

//Plugins
"plugins/jquery-transit"],

function(app, Backbone, genericElement) {

  var powerSupply = _.extend({}, genericElement, {

    Views: {

      titleBar: genericElement.Views.titleBar.extend({
        template: "application/wizard/sections/powerSupply/titleBar",
        tagName:  "h3",

        initialize: function() {
          this.model.unbind("updateViews", this.setLabel);
          this.model.bind("updateViews", this.setLabel);
          this.model.titleBarView = this;
        },

        setLabel: function() {
          var captionToInsert = $.i18n._(this.get("packageClassLabel"));

          if (this.get("partOfKit"))
            captionToInsert += " (KIT)";

          if ( (this.get("packageClassLabel") !== null) && (this.get("packageClassLabel") !== "") ) {
            this.titleBarView.$el.find(".titleBarcontent span").html(captionToInsert);

            if (this.get("partOfKit"))
              this.titleBarView.$el.find(".titleBarcontent span").css("color", "#a0a2a3");

            this.titleBarView.$el.find(".titleBarcontent span").fadeIn(200);
          }
          else
            this.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel: function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        enable: function() {
          this.$el.trigger("click");
        },

        disable: function() {
          this.$el.trigger("click");
        },

        onClose: function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      }),

      content: genericElement.Views.content.extend({
        template: "application/wizard/sections/powerSupply/content",
        className: "powerSupply",

        events: {
          "change #powerSupply"     : "powerSupplyChanged",
          "click .toggleInfoButton" : "toggleInfos"
        },

        serialize : function() {
          return { model: this.model, app : app };
        },

        initialize: function() {
          this.model.set("view", this);

          this.model.unbind("updateViews", this.setDetails);
          this.model.bind("updateViews", this.setDetails, this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);
          
          if(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
            this.model.accessoryLineChosenEventHandler(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
        },

        toggleInfos : function(e) {
          return genericElement.Views.content.prototype.toggleInfos(e, this);
        },

        disableSection: function(force) {
          if (!this.model.get("enabled") || ((force !== undefined) && (force === true))) {
            this.$el.find("#powerSupply option").removeAttr("selected");
            this.$el.find("#powerSupply").attr("disabled", "disabled");
            this.$el.find("#powerSupply").removeAttr("rel");
            this.$el.find("span").remove();
            this.$el.find(".exampleImage").attr("src", "");
            this.$el.find(".description").html("");
            this.$el.find(".linkContainer").html("");
            window.customizeFormElements.call();
            this.hideDetails();
          }
        },

        enableSection: function() {
          if (this.model.get("enabled")) {
            this.$el.find("select#powerSupply").removeAttr("disabled");
            this.$el.find("span#selectpowerSupply").removeClass("disabled");
            //this.showDetails();
          }
        },

        populateDropDown: function(pss) {
          var dropDownView = this.$el.find("select#powerSupply");
          dropDownView.children("option:first").attr("selected", "selected");
          dropDownView.children("option:not(:first)").remove();

          for (var i = 0; i < pss.length; i++)
            dropDownView.append("<option value=\"" + pss[i].packageClassId + "\">" + $.i18n._(pss[i].packageClassLabel) + "</option>");
        },

        powerSupplyChanged: function(event) {
          this.hideDetails();
          this.showLoader();
          var powerSupplyId     = ($(event.target).val() === "") ? undefined : $(event.target).val();
          var powerSupplyLabel  = ($(event.target).children("option:selected").text() === "") ? undefined : $(event.target).children("option:selected").text();
          this.model.set("name", powerSupplyLabel);
          this.model.set("id", powerSupplyId);
          window.BticinoS4B.solution.intrusionDetection.inserted = true;
        },

        //Retrieve and set the accessory line's details
        setDetails: function() {
          if ((this.model.get("productCode"))&&(this.model.get("productCode")!=="")) {
            this.$el.find(".exampleImage").attr("src", "/images/"+(this.model.get("image") ? this.model.get("image") : "no-preview.jpg"));
            this.$el.find(".productCode").html(this.model.get("productCode"));

            if (this.model.get("packageClassDescription")) {
              if ($.i18n._(this.model.get("packageClassDescription")).length>360)
              {
                this.$el.find(".description").text($.i18n._(this.model.get("packageClassDescription")).substring(0, 360));
                this.$el.find(".description").append("<br /><br /><span class='tooltip'>"+$.i18n._("IDS_W1_9032")+" ›</span>");
                this.$el.find(".tooltip").qtip({
                  content   : $.i18n._(this.model.get("packageClassDescription")),
                  show      : 'click',
                  style     : {
                    classes  : 'ui-tooltip-shadow'
                  },
                  position  : {
                    at: 'center left',
                    my: 'center right'
                  },
                  effect    : function() { $(this).fadeIn(200); }
                });
              }
              else
                this.$el.find(".description").text($.i18n._(this.model.get("packageClassDescription")));
            }

            this.$el.find(".linkContainer").html("");

            if (this.model.get("packageInDepth")!==null)
            {
              var urlLink = BticinoS4B.Instances.Models.ApplicationModel.composeProductUrl(this.model.get("productCode"));
              this.$el.find(".linkContainer").append('<li class="packageInDepth"><a data-bypass href="'+urlLink+'" target="_blank"><div class="button"><img src="/assets/img/indepth-icon.png" class="icon indepth"/><span class="text">'+$.i18n._("IDS_W1_9015")+'</span></div></a></li>');
            }

            if (this.model.get("links")) {
              for (var i = 0; i < this.model.get("links").papers.length; i++) {
                var paperToAppend = this.model.get("links").papers[i];
                this.$el.find(".linkContainer").append('<li class="paper"><a data-bypass target="_blank" href="' + paperToAppend.link + '"><div class="button"><img src="/assets/img/paper-icon.png" class="icon paper"/><span class="text">' + $.i18n._(paperToAppend.label) + '</span></div></a></li>');
                break;
              }

              for (var j = 0; j < this.model.get("links").images.length; j++) {
                var imageToAppend = this.model.get("links").images[j];
                this.$el.find(".linkContainer").append('<li class="image"><a data-bypass target="_blank" href="' + imageToAppend.link + '"><div class="button"><img src="/assets/img/image-icon.png" class="icon image"/><span class="text">' + $.i18n._(imageToAppend.label) + '</span></div></a></li>');
                break;
              }

              for (var k = 0; k < this.model.get("links").videos.length; k++) {
                var videoToAppend = this.model.get("links").videos[k];
                this.$el.find(".linkContainer").append('<li class="video"><a data-bypass target="_blank" href="' + videoToAppend.link + '"><div class="button"><img src="/assets/img/video-icon.png" class="icon video"/><span class="text">' + $.i18n._(videoToAppend.label) + '</span></div></a></li>');
                break;
              }
            }
            this.hideLoader(this.showDetails);
          }
          else
            this.hideLoader(this.hideDetails);
        },

        showDetails: function() {
          this.$el.find(".exampleImage").fadeIn(200);
          this.$el.find(".productCode").fadeIn(200);
          this.$el.find(".description").fadeIn(200);
          this.$el.find(".linkContainer").fadeTo(200,1);
        },

        hideDetails: function() {
          this.$el.find(".exampleImage").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".productCode").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".description").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".linkContainer").fadeTo(200,0);
        },

        showLoader: function() {
          this.$el.find(".mini-loader").fadeIn(200);
        },

        hideLoader: function(callback) {
          var that = this;
          this.$el.find(".mini-loader").fadeOut(200, function() {
            $(this).hide();
            if (callback)
              callback.call(that);
          });
        },

        isOpen: function() {
          return this.$el.css("display") == "block";
        },

        afterRender: function() {

          if ((this.model.get("packageClassId"))&&(this.model.get("packageClassId")!=="")) {
            this.setDetails();
          }

          setTimeout(function() {
            window.customizeFormElements.call();
          }, 0);

        },

        onClose: function(){
          this.model.unbind("change #powerSupply");
        }
      })

    },

    Model: genericElement.Model.extend({
      defaults: {
        enabled           : false,
        id                : undefined,

        catalogId         : undefined,
        image             : undefined,
        links             : {
          images: [],
          papers: [],
          videos: []
        },
        price             : undefined,
        productCode       : undefined,
        productDescription: undefined,
        productLabel      : undefined,
        maxZoneNumber     : undefined
      },

      initialize: function() {
        var that = this;

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen',  this.accessoryLineChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen',    this.accessoryLineChosenEventHandler, this);

        //Bind on accessory line removal
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:removed', this.accessoryLineRemovedEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:removed',   this.accessoryLineRemovedEventHandler, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",                  this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",                    this.deliverModel, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project",                          this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",                            this.loadProject, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",                this.deliverCurrent, this);

        window.BticinoS4B.eventAggregator.unbind("powerSupply:addedFromKit",              this.productAddedFromKitEventHandler);
        window.BticinoS4B.eventAggregator.bind("powerSupply:addedFromKit",                this.productAddedFromKitEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("removeKitItems",                        this.removeKitItems);
        window.BticinoS4B.eventAggregator.bind("removeKitItems",                          this.removeKitItems, this);

        this.unbind("change:id",                                            this.idChanged);
        this.bind("change:id",                                              this.idChanged);

      },

      accessoryLineChosenEventHandler : function(accessoryLineId) {
        this.fetchPSs(accessoryLineId);
        this.set("accessoryLineId", accessoryLineId);
        this.disableSection();
        this.enableSection();
      },

      accessoryLineRemovedEventHandler : function(accessoryLineId) {
        this.set("accessoryLineId", "");
        this.removeValues();
        this.disableSection();
      },

      productAddedFromKitEventHandler : function(addedPowerSupply) {
        this.set("partOfKit", true);
        this.set("kitValue",  1);
        this.set("id", addedPowerSupply.packageClassId);
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen',  this.accessoryLineChosenEventHandler);
        this.trigger("updateViews");
        this.trigger("render:requested");
      },

      removeKitItems                  : function() {
        if (this.get("partOfKit"))
        {
          this.removeValues();
          this.trigger("updateViews");
          this.trigger("render:requested");
        }
      },

      deliverModel: function() {
        var externalItems;
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.powerSupply = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.powerSupply = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.powerSupply = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.powerSupply = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.powerSupply = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.powerSupply = this;
              break;
          };    
        BticinoS4B.Instances.Models.ApplicationModel.set("powerSupply", this);

        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i            = 0;

        dataProvider.addItems("externalItems", {
          productCode       : this.get("productCode"),
          productLabel      : this.get("productLabel"),
          packageClassLabel : this.get("packageClassLabel"),
          kitValue          : this.get("kitValue"),
          partOfKit         : this.get("partOfKit"),
          quantity          : 1,
          price             : this.get("price")
        });

        if (this.get("secondaryProducts"))
        {
          for (i=0; i<this.get("secondaryProducts").length; i++)
          {
            dataProvider.addItems("externalItems", {
              productCode       : this.get("secondaryProducts")[i].productCode,
              productLabel      : this.get("secondaryProducts")[i].productLabel,
              packageClassLabel : this.get("secondaryProducts")[i].packageClassLabel,
              kitValue          : this.get("kitValue"),
              partOfKit         : this.get("partOfKit"),
              quantity          : 1,
              price             : this.get("secondaryProducts")[i].price
            });
          }
        }
      },

      fetchPSs: function(accessoryLineId) {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("400", function(data) {

          //Converting specialData from json to object
          for (var i=0; i<data.packages.length; i++)
            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

          //Sorting elements by packageClassId
          that.fetchedPS = data.packages;

          if (that.get("view")) that.get("view").populateDropDown(that.fetchedPS);
        }, undefined, false);
      },

      getPackageDetails: function(packageClassId) {
        var that = this;
        var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

        if ((packageClassId)&&(packageClassId!==null)&&(packageClassId!=="")) {
          accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
            data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var products          = _.filter(data.products,function(product) {return (product.mnemonic===1);});

            if (products.length>0)
              products=products[0];

            _.extend(that.attributes, products);

            if ( (that.get("id")) && (that.get("id")!==null) && (that.get("id")!=="") )
            {

              that.get("stepEventAggregator").trigger("powerSupply:chosen",that);
              window.BticinoS4B.eventAggregator.trigger("powerSupply:chosen", that);
              that.trigger("updateViews");
              BticinoS4B.Instances.Models.ApplicationModel.set("powerSupplyId", that.get("id"));

            }
            else
            {

              this.get("stepEventAggregator").trigger("powerSupply:removed");
              window.BticinoS4B.eventAggregator.trigger("powerSupply:removed", that);
              that.trigger("updateViews");
              BticinoS4B.Instances.Models.ApplicationModel.set("powerSupplyId", null);

            }

            var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            that.set("secondaryProducts", secondaryProducts);

            //Update currents consumption indicator
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          });
        }
        else
        {
          this.get("stepEventAggregator").trigger("powerSupply:removed");
          window.BticinoS4B.eventAggregator.trigger("powerSupply:removed");
          this.removeValues();
          that.trigger("updateViews");
          this.get("view").hideLoader();
        }
      },

      idChanged: function(e) {
        var that                      = this;
        var selectedPS                = _.filter(this.fetchedPS, function(ps){return ps.packageClassId==that.id;});

        if (selectedPS.length===0)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(this.get("id"), function(data) {
            _.extend(that.attributes, data);
            that.getPackageDetails(that.get("id"));
            that.trigger("render:requested");
          });
        else
        {
          _.extend(that.attributes, selectedPS[0]);
          that.getPackageDetails(this.get("id"));
          that.trigger("render:requested");
        }
      },

      disableSection: function() {
        var that = this;

        if (this.get("enabled")) {
          this.set("enabled", false);
          this.get("view").disableSection();
          this.titleBarView.removeLabel();
          if (this.get("view").isOpen()) this.titleBarView.disable();
        }

        this.set("id", undefined);
      },

      enableSection: function() {
        var that = this;
        if (!this.get("enabled")) {
          this.set("enabled", true);
          this.get("view").enableSection();
        }
      },

      removeValues  :  function() {
        this.set("image","");
        this.set("links",{images:[], papers:[], videos:[]});
        this.set("mnemonic","");
        this.set("name","");
        this.set("optionalPackages","");
        this.set("packageActuator","");
        this.set("packageClassId",null);
        this.set("packageClassLabel",null);
        this.set("packageInDepth","");
        this.set("packageLoad","");
        this.set("price","");
        this.set("productCode","");
        this.set("productInDepth","");
        this.set("productLabel","");
        this.set("productDescription","");
        this.set("wizardChoiceDescription","");
        this.set("wizardChoiceLabel","");
        this.set("packageClassDescription","");
        this.set("packageClassId","");
        this.set("packageClassLabel","");
        this.set("partOfKit", false);
        this.set("id","");
        this.get("stepEventAggregator").trigger("powerSupply:removed");
      },

      loadProject   : function(model) {
        var powerSupply = model.powerSupply;
        if (powerSupply)
        {
          this.set("id",             powerSupply.packageClassId);
          this.set("partOfKit",      powerSupply.partOfKit);
          this.set("kitValue",       powerSupply.kitValue);
          this.trigger("render:requested");
        }
      },

      onClose : function() {
        this.unbind("change:id");
      },

      deliverCurrent : function() {
        if (this.get("specialVars")) {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          var currentConsumption        = this.get("specialVars").currentConsumption;

          if (currentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
        }
      }

    })

  });

  // Required, return the module for AMD compliance
  return powerSupply;

});